module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Ke-Lb.c377f48b.png";